<template>
  <div class="carousel">
    <swiper
      :options="swiperOption"
      ref="mySwiper"
      :space-between="50"
      @swiper="onSwiper"
      @slideChange="onSlideChange"
    >
      <swiper-slide
        v-for="(item,index) in menuData"
        :key="index"
      ><a
          :href="item.link"
          v-if="item.link"
        >{{item.title}}</a>
        <div
          class="carousel__btn"
          :class="{'active':isActiveBtn===item.value}"
          ref="carouselBtn"
          @click.stop="$_onActive(index)"
        >
          <span>
            <slot name="leftItem"></slot>
          </span>
          <span>{{item.title}}</span>
          <span>
            <slot name="rightItem"></slot>
          </span>
        </div>
      </swiper-slide>
      <div
        class="swiper-button-prev"
        slot="button-prev"
      >
        <slot name="prevBtn"></slot>
      </div>
      <div
        class="swiper-button-next"
        slot="button-next"
      >
        <slot name="nextBtn"></slot>
      </div>
    </swiper>
  </div>
</template>
<script>
// Import vue-awesome-swiper Vue.js components
import { swiper, swiperSlide } from "vue-awesome-swiper";
//Import Swiper styles
import "swiper/css/swiper.css";
export default {
  name: "Carousel",
  components: {
    swiper,
    swiperSlide,
  },
  data: () => ({
    isActiveBtn: "",
    swiperOption: {
      slidesPerView: "auto",
      freeMode: true,
      mousewheel: true,
      keyboard: true,
      navigation: {
        // arrow
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    },
  }),
  methods: {
    $_initData() {
      this.isActiveBtn = this.menuData[0].value;
    },
    onSwiper(swiper) {
      console.log(swiper);
    },
    onSlideChange() {
      console.log("slide change");
    },
    $_onActive(index) {
      this.isActiveBtn = this.menuData[index].value;
      this.$emit("input", {
        value: this.isActiveBtn,
        index: index,
        title: this.menuData[index].title,
      });
    },
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
  },
  props: {
    menuData: {
      type: Array,
    },
  },
  mounted() {
    this.$_initData();
  },
};
</script>
<style lang="scss" scoped>
.swiper-container {
  width: 100%;
  height: 50px;
  .swiper-slide {
    text-align: center;
    line-height: 44px;
    width: 150px;
    a {
      display: inline-block;
      padding: 0 15px;
      text-decoration: none;
      color: #848fa0;
      &:hover {
        color: #116795;
      }
    }
    .carousel__btn {
      display: inline-block;
      width: 150px;
      text-decoration: none;
      color: #848fa0;
      border-bottom: 3px solid #d7dee7;
      &:hover {
        cursor: pointer;
        color: #116795;
      }
      &:active {
        color: #116795;
      }
    }
    .active {
      color: #116795;
      border-bottom: 3px solid #116795;
    }
  }
  .swiper-button-disabled {
    visibility: hidden;
  }
}
</style>